<template>
  <div>
    <div
      style="margin: 0"
      class="loading-waiting"
      v-bind:style="{ display: finish == true ? 'none' : '' }"
    >
      <div>
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
        <div class="load-wrapp">
          <div class="load-6">
            <div class="letter-holder">
              <div class="l-1 letter">l</div>
              <div class="l-2 letter">o</div>
              <div class="l-3 letter">a</div>
              <div class="l-4 letter">d</div>
              <div class="l-5 letter">i</div>
              <div class="l-6 letter">n</div>
              <div class="l-7 letter">g</div>
              <div class="l-8 letter">.</div>
              <div class="l-9 letter">.</div>
              <div class="l-10 letter">.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <h3 style="font-weight: 700">Log Customer Contact</h3>
        </v-col>

        <v-col cols="12">
          <v-card>
            <v-card-title>
              <div class="contact-filter-panel">
                <div class="contact-filter-copy">
                  <span class="contact-filter-label">Contact Type</span>
                  <span class="contact-filter-value">{{
                    activeContactType.title
                  }}</span>
                </div>
                <v-btn
                  color="primary"
                  dark
                  depressed
                  style="font-size: 12px"
                  @click="contact_type_dialog = true"
                >
                  Select Type
                  <v-icon right dark>mdi-filter-variant</v-icon>
                </v-btn>
              </div>
              <v-spacer></v-spacer>
              <v-form
                @submit.prevent="searchWord()"
                style="display: flex; align-items: center"
                class="search-area"
              >
                <v-text-field
                  v-model="search"
                  label="Customer Number, Customer Name"
                  single-line
                  hide-details
                  autocomplete="off"
                  style="width: 480px"
                ></v-text-field>
                <v-btn color="primary" type="submit" style="font-size: 12px">
                  Search
                  <v-icon right dark> mdi-magnify </v-icon>
                </v-btn>
                <div style="width: 10px"></div>
              </v-form>
              <v-btn
                color="red"
                dark
                @click="clearFilter"
                class="screen"
                style="font-size: 12px"
              >
                Clear All</v-btn
              >
            </v-card-title>

            <v-card-text>
              <div class="cover-table">
                <div class="table-invoice" style="position: relative">
                  <v-data-table
                    :headers="headers"
                    :items="datalist"
                    :items-per-page="number_INC()"
                    class="elevation-3"
                    fixed-header
                    hide-default-footer
                    no-data-text
                    height="600px"
                    id="log-invoice-table"
                  >
                    <template v-slot:[`item.contact_remark`]="{ item }">
                      <label>{{ item.contact_remark || "" }}</label>
                    </template>
                  </v-data-table>
                  <div v-if="datalist.length === 0" class="no-contact-overlay">
                    No contact data for {{ activeContactType.title }}
                  </div>

                  <div class="d-flex" style="float: right; margin-top: 20px">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin-right: 10px;
                      "
                    >
                      Items per page:
                    </div>

                    <select
                      style="width: 80px; margin-right: 20px"
                      class="style-chooser"
                      v-model="item_per_page"
                      @change="item_per_page_inc()"
                    >
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="300">300</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                    <v-pagination
                      style="justify-content: flex-end"
                      v-model="page"
                      :length="page_total"
                      :total-visible="10"
                      @input="pageChange()"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="contact_type_dialog" max-width="520px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Select Contact Type</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="contact_type_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item
              v-for="contactType in contact_types"
              :key="contactType.key"
              link
              :class="{
                'contact-type-active':
                  contactType.key === active_contact_type_key,
              }"
              @click="selectContactType(contactType.key)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ contactType.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon
                v-if="contactType.key === active_contact_type_key"
              >
                <v-icon color="primary">mdi-check</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const contactTypes = [
  { key: "billing", title: "ผู้รับวางบิล", index: 0 },
  { key: "receipt", title: "ผู้รับใบเสร็จ", index: 1 },
  { key: "debt", title: "ผู้ติดต่อทวงหนี้", index: 2 },
  { key: "wht", title: "ติดตามเอกสาร WHT", index: 3 },
  { key: "payment", title: "สอบถามการชำระ", index: 4 },
  { key: "other", title: "อื่นๆ", index: 5 },
];

// const emptyContacts = contactTypes.map((contactType) => ({
//   contact_type: contactType.title,
//   contact_name: "",
//   contact_tel: "",
//   contact_email: "",
//   contact_remark: "",
// }));

// const customerContacts = [
//   {
//     customer_no: "CUST-0001",
//     customer_name: "INET Mock Customer",
//     contact_user: "admin demo",
//     created_at: "2026-05-19T09:30:00+07:00",
//     contacts: [
//       {
//         contact_type: "ผู้รับวางบิล",
//         contact_name: "test",
//         contact_tel: "",
//         contact_email: "billing@example.com",
//         contact_remark: "02-050-4808",
//       },
//       {
//         contact_type: "ผู้รับใบเสร็จ",
//         contact_name: "test",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//       {
//         contact_type: "ผู้ติดต่อทวงหนี้",
//         contact_name: "test",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//       {
//         contact_type: "ติดตามเอกสาร WHT",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//       {
//         contact_type: "สอบถามการชำระ",
//         contact_name: "tesr",
//         contact_tel: "",
//         contact_email: "test1@mail.com",
//         contact_remark: "",
//       },
//       {
//         contact_type: "อื่นๆ",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//     ],
//   },
//   {
//     customer_no: "CUST-0002",
//     customer_name: "JV Sample Customer",
//     contact_user: "finance user",
//     created_at: "2026-05-18T14:10:00+07:00",
//     contacts: [
//       {
//         contact_type: "ผู้รับวางบิล",
//         contact_name: "Somchai",
//         contact_tel: "081-111-1111",
//         contact_email: "somchai@example.com",
//         contact_remark: "Send bill by email",
//       },
//       {
//         contact_type: "ผู้รับใบเสร็จ",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//       {
//         contact_type: "ผู้ติดต่อทวงหนี้",
//         contact_name: "Suda",
//         contact_tel: "082-222-2222",
//         contact_email: "suda@example.com",
//         contact_remark: "",
//       },
//       {
//         contact_type: "ติดตามเอกสาร WHT",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "tax@example.com",
//         contact_remark: "WHT every month",
//       },
//       {
//         contact_type: "สอบถามการชำระ",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//       {
//         contact_type: "อื่นๆ",
//         contact_name: "",
//         contact_tel: "",
//         contact_email: "",
//         contact_remark: "",
//       },
//     ],
//   },
//   {
//     customer_no: "CUST-0003",
//     customer_name: "No Contact Sample",
//     contact_user: "viewer demo",
//     created_at: "2026-05-17T11:00:00+07:00",
//     contacts: emptyContacts.map((contact) => ({ ...contact })),
//   },
// ];

export default {
  name: "LogCustomerContact",
  data: () => ({
    page: 1,
    page_total: 1,
    item_per_page: 100,
    contact_type_dialog: false,
    active_contact_type_key: "billing",
    contact_types: contactTypes,
    datalist: [],
    search: "",
    finish: true,
    headers: [
      {
        text: "Customer Number",
        sortable: true,
        value: "customer_no",
        width: "220px",
        class: "log-invoice",
      },
      {
        text: "Customer Name",
        value: "customer_name",
        width: "320px",
        sortable: true,
        align: "left",
      },
      {
        text: "Contact Name",
        value: "contact_name",
        width: "260px",
        sortable: true,
        align: "left",
      },
      {
        text: "Tel.",
        value: "contact_tel",
        width: "200px",
        sortable: true,
        align: "center",
      },
      {
        text: "Email",
        value: "contact_email",
        width: "280px",
        sortable: true,
        align: "left",
      },
      {
        text: "Remark",
        value: "contact_remark",
        width: "280px",
        sortable: false,
        align: "left",
      },
      {
        text: "วันที่แก้ไข",
        value: "contact_date",
        width: "220px",
        sortable: true,
        align: "center",
      },
      {
        text: "User",
        value: "contact_user",
        width: "220px",
        sortable: true,
        align: "center",
      },
    ],
  }),
  computed: {
    activeContactType() {
      return (
        this.contact_types.find(
          (contactType) => contactType.key === this.active_contact_type_key
        ) || this.contact_types[0]
      );
    },
    getBizId() {
      const bizId = localStorage.getItem("biz_id") || "";
      return bizId;
    },
  },
  created() {
    this.getTableData();
  },
  methods: {
    resolveDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleString("en-GB").replace(",", "");
    },
    async getTableData() {
      this.finish = false;
      try {
        const headers = {
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        };
        const response = await this.axios.get(
          process.env.VUE_APP_API + "/log/customer_contact",
          {
            params: {
              size: Number(this.item_per_page),
              page: this.page,
              search: String(this.search || ""),
              type: this.activeContactType.title,
              biz_id: this.getBizId,
            },
            headers,
          }
        );
        const responseData = response.data || {};
        const contacts = Array.isArray(responseData.data)
          ? responseData.data
          : [];

        this.datalist = contacts.map((contact) => ({
          customer_no: contact.customer_no || "",
          customer_name: contact.customer_name || "",
          contact_name: contact.contact_name || "",
          contact_tel: contact.tel || "",
          contact_email: contact.email || "",
          contact_remark: contact.remark || "",
          contact_date: this.resolveDate(contact.created_at) || "",
          contact_user: contact.action_by_name || "",
        }));
        this.page_total = Number(responseData.count_page) || 1;
      } catch (e) {
        this.datalist = [];
        this.page_total = 1;
        if (e.response && e.response.status === 401) {
          localStorage.clear();
          this.$router.push("/login");
        }
        console.error(e);
      } finally {
        this.finish = true;
      }
    },
    selectContactType(type) {
      this.active_contact_type_key = type;
      this.contact_type_dialog = false;
      this.page = 1;
      this.getTableData();
    },
    searchWord() {
      this.page = 1;
      this.getTableData();
    },
    clearFilter() {
      this.search = "";
      this.page = 1;
      this.getTableData();
    },
    pageChange() {
      this.getTableData();
    },
    item_per_page_inc() {
      this.page = 1;
      this.getTableData();
    },
    number_INC() {
      return Number(this.item_per_page);
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Bai_Jamjuree";
  src: url("~@/assets/Bai_Jamjuree/BaiJamjuree-Medium.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  vertical-align: middle;
}

#log-invoice-table {
  th.text-start,
  th.text-center,
  th.text-left {
    background-color: #ececec !important;
  }

  th.text-start.log-invoice {
    position: sticky;
    z-index: 5 !important;
    left: 0px !important;
    padding-top: 14px;
    background: linear-gradient(
      90deg,
      #ececec 99%,
      rgba(101, 101, 101, 1) 100%
    ) !important;
  }

  th.text-start:first-child {
    background-color: #ececec !important;
    position: sticky;
    left: 0;
    z-index: 4 !important;
  }

  tbody {
    td.text-start,
    td.text-center {
      font-family: "Bai_Jamjuree" !important;
      position: relative !important;
      left: 0;
      top: auto;
      background-color: white;
      background: linear-gradient(
        90deg,
        rgba(253, 253, 253, 1) 99%,
        rgb(255, 255, 255) 100%
      ) !important;
    }

    td.text-start:first-child {
      position: sticky !important;
      width: 200px !important;
      left: 0 !important;
      z-index: 1 !important;
      background: linear-gradient(
        90deg,
        #ffffff 99%,
        rgba(101, 101, 101, 1) 100%
      ) !important;
    }
  }

  .v-data-table__empty-wrapper td {
    padding: 0 !important;
    text-align: center !important;
  }
}

.cover-table {
  width: 100%;
  overflow: auto;
  font-family: "Bai_Jamjuree" !important;
}

.contact-filter-panel {
  align-items: center;
  background: linear-gradient(90deg, #eef7ff 0%, #f8fbff 100%);
  border: 1px solid #d8e8f7;
  border-radius: 8px;
  display: flex;
  gap: 14px;
  padding: 10px 12px;
}

.contact-filter-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  min-width: 180px;
}

.contact-filter-label {
  color: #6f7c86;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.contact-filter-value {
  color: #1976d2;
  font-size: clamp(14px, 1.5vw, 16px);
  font-weight: 500;
}

.contact-type-active {
  background-color: rgba(25, 118, 210, 0.08) !important;
  color: #1976d2 !important;
  font-weight: 700 !important;
}

.no-contact-data {
  align-items: center;
  color: #757575;
  display: flex;
  font-family: "Bai_Jamjuree" !important;
  font-size: 14px;
  justify-content: center;
  min-height: 430px;
  padding: 16px;
  text-align: center;
  width: 100%;
}

.no-contact-overlay {
  align-items: center;
  bottom: 56px;
  color: #757575;
  display: flex;
  font-family: "Bai_Jamjuree" !important;
  font-size: 14px;
  justify-content: center;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  text-align: center;
  top: 48px;
}

.container {
  font-family: "Bai_Jamjuree" !important;
  background-color: rgb(250, 250, 250);
}

.v-card-title {
  font-family: "Bai_Jamjuree" !important;
}

@media (min-width: 960px) {
  .container {
    max-width: 100%;
    background-color: rgb(250, 250, 250);
  }
}

.mobile {
  display: none;
}

@media only screen and (max-width: 580px) {
  .search-area {
    display: flex !important;
  }

  .screen {
    display: none !important;
  }

  .mobile {
    display: block !important;
  }
}

.loading-waiting {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: #ecf5ff62;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.load-4 .ring-1 {
  animation: loadingD 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
}

@keyframes loadingD {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ring-1 {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  padding: 7px;
  border: 8px dashed #4b9cdb;
  border-radius: 100%;
}

.load-6 .letter {
  animation-name: loadingF;
  animation-duration: 1.6s;
  animation-iteration-count: infinite;
  animation-direction: linear;
}

.letter-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b9cdb;
  font-size: 20px;
}

.l-1 {
  animation-delay: 0.48s;
}

.l-2 {
  animation-delay: 0.6s;
}

.l-3 {
  animation-delay: 0.72s;
}

.l-4 {
  animation-delay: 0.84s;
}

.l-5 {
  animation-delay: 0.96s;
}

.l-6 {
  animation-delay: 1.08s;
}

.l-7 {
  animation-delay: 1.2s;
}

.l-8 {
  animation-delay: 1.32s;
}

.l-9 {
  animation-delay: 1.44s;
}

.l-10 {
  animation-delay: 1.56s;
}

@keyframes loadingF {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.table-invoice {
  width: 100%;
  overflow: auto;
}

.v-data-table {
  overflow: auto;
  width: auto;
}

.v-data-table th {
  background-color: rgb(203, 236, 199);
}

tr {
  background-color: white !important;
}

th {
  font-size: 14px !important;
}

.style-chooser {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 1px;
  width: 100%;
  height: 48px;
  padding-left: 7px;
  cursor: pointer;
}

.theme--light.v-label {
  color: rgba(0, 0, 0, 0.6);
  left: 5px !important;
}
</style>
